import { getAppConfigSingleton } from "@expert/app-config";
import { useExpertUniversityConfiguration } from "@expert/expert-university";
import { useEffect } from "react";

import { isSimulatedVoiceTask, useActiveTask, useAgentStore, usePartner } from "@/sdk";

export type OverrideType = "PARTNER_TOOL";

export function useExpertUniversityOverrides(overrideType?: OverrideType) {
    const activeTask = useActiveTask();
    const workspacePartner = usePartner();
    const { activity: currentActivity } = useAgentStore((state) => state);

    const { setMostRecentSessionId, mostRecentSessionId, trainingPartner } = useExpertUniversityConfiguration();
    useEffect(() => {
        if (isSimulatedVoiceTask(activeTask)) {
            setMostRecentSessionId(activeTask.id);
        }
    }, [activeTask, setMostRecentSessionId]);

    useEffect(() => {
        if (mostRecentSessionId && currentActivity !== "Training" && currentActivity !== "Residency") {
            setMostRecentSessionId(undefined);
        }
    }, [currentActivity, setMostRecentSessionId, mostRecentSessionId]);

    if (overrideType === "PARTNER_TOOL") {
        return { shouldOpen: false, url: null };
    }

    if (!overrideType && trainingPartner && trainingPartner !== workspacePartner) {
        const { feedback, feedbackType } = getAppConfigSingleton().getPartnersConfig(trainingPartner).features;
        return { feedback, feedbackType };
    }
}
